/**
 * Gemini 4 Argon (Google, GA 2026-10-13; API id `gemini-4-argon`).
 *
 * Google sells it at an introductory $2 / $10 per 1M tokens (cached input 95%
 * off) through 2026-11-30, then $4 / $20 from 2026-12-01. Credits follow that
 * cost, so the billing tier switches on the same date without a deploy:
 * until then it bills like GPT-6.1 Sol ($2/$10, 0.5x, no input charge), from
 * then on like Claude Opus 5.5 / Muse Wonder 1.0 ($4/$20, 1x plus the Opus
 * uncached-input charge in @/data/edge.ts).
 *
 * Client-safe (no imports): the chat card's displayed multiplier reads it too.
 */
export const GEMINI_4_ARGON_SLUG = 'gemini-4-argon';

/** 2026-12-01 00:00 UTC, when the introductory price ends. */
export const GEMINI_4_ARGON_PROMO_ENDS_AT = Date.UTC(2026, 11, 1);

/** True while Google charges the introductory $2 / $10 per 1M. */
export function isGemini4ArgonPromoPrice(now: number = Date.now()): boolean {
  return now < GEMINI_4_ARGON_PROMO_ENDS_AT;
}

/** Word multiplier for Gemini 4 Argon output at `now`. */
export function gemini4ArgonMultiplier(now: number = Date.now()): number {
  return isGemini4ArgonPromoPrice(now) ? 0.5 : 1;
}
